import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import {
  CleanFillGroupViewModel,
  CleanFillPolicyCategory,
  CleanFillPolicyViewModel
} from '@services/cleanfill-api/cleanfill-api.generated';
import { HttpPoliciesService } from '@services/cleanfill-core/http-policies/http-policies.service';
import { Permission } from '@services/auth/permission.enum';

@Injectable({
  providedIn: 'root'
})
export class StorePoliciesService {
  private policiesSubj$ = new BehaviorSubject<CleanFillPolicyViewModel[]>([]);
  policies$ = this.policiesSubj$.asObservable();

  subscription = new Subscription();
  constructor(private httpGroups: HttpPoliciesService) {}

  loadPolicies(): void {
    const sub = this.httpGroups.getAllPolicies().subscribe(policies => {
      this.policiesSubj$.next(policies);
    });
    this.subscription.add(sub);
  }

  getPoliciesByCategorySnapshot(category: CleanFillPolicyCategory): CleanFillPolicyViewModel[] {
    const policies = this.policiesSubj$.value;
    return policies.filter(policy => policy.category === category) || [];
  }

  getPolicyUniqueIdsByPolicyName(extraPoliciesMap: Permission[]): CleanFillPolicyViewModel[] {
    return extraPoliciesMap.map(policy => this.getPolicyUniqueIdByPolicyName(policy));
  }

  getPolicyUniqueIdByPolicyName(name: Permission): CleanFillPolicyViewModel {
    return this.policiesSubj$.value.find(policy => policy.name === name);
  }
}
